import { authenticatedFetcher } from '@/lib/swr';
import type { ApiResponse } from '@/types/api-response';
import type { AttachmentUploadResponseDto } from '@/types/attachments';
import { PP_BASE_URL } from '@/lib/env';

export interface UploadAttachmentOptions {
  referenceNumber: string;
  referenceName: string;
  file: File;
  locale: string;
}

export async function uploadAttachment({
  referenceNumber,
  referenceName,
  file,
  locale,
}: UploadAttachmentOptions): Promise<AttachmentUploadResponseDto> {
  const baseUrl = (PP_BASE_URL ?? '').replace(/\/$/, '');
  const formData = new FormData();
  formData.append('ReferenceNumber', referenceNumber ?? '');
  formData.append('ReferenceName', referenceName ?? '');
  formData.append('File', file);

  let response: ApiResponse<AttachmentUploadResponseDto> | null = null;
  try {
    response = await authenticatedFetcher<ApiResponse<AttachmentUploadResponseDto>>(`${baseUrl}/attachments`, {
      method: 'POST',
      body: formData,
    });
  } catch (err: any) {
    console.error('Failed to upload attachment:', err);
  }
  if (!response?.data?.fileGuid) {
    const errorMessage = locale === 'ar' ? 'فشل رفع المستند' : 'Failed to upload document';
    throw new Error(errorMessage);
  }
  return response.data;
}
